import { useEffect, useState } from "react"

import { intvVariant2JSON, SELECTION_TYPES } from "@meddbriefer/scenario-data"
import { useScenario } from "../../contexts/ScenarioContext"

import {difference, logicalAndCorrectness, logicalOrCorrectness, radioCorrectness} from "./util"

import Panel from "../Panel"
import PromptsForm from "./PromptsForm";
import { interventionStates, intvResults, intvPromptResponsesWhereCorrectnessMatters
    //good, bad, neutral 
} from "@meddbriefer/feedback-data/analysisData"
import { getPrescribedInvAnswers } from "@meddebriefer/prompt-answer-grading"

const FORM_MODES = Object.freeze({
    DISP_NONE: 1,
    DISP_DIST_PROMPTS: 2,
    DISP_PROMPTS: 3
})


export default function IntvForm({intvID}) {
    const {
        currPhase,
        currSubPhase,
        getIntvVariantHistory,
        getTimestamp,
        logIntv,
        scenario,
        setCurrIntv,
        //setCurrIntvCat,
        setShowIntvSelection,
    } = useScenario()

    const [form, setForm] = useState(null)
    const [formMode, setFormMode] = useState(FORM_MODES.DISP_NONE)
    const [distPromptState, setDistPromptState] = useState(null);
    const [intvVariant, setIntvVariant] = useState(null)
    const [stringVariant, setStringVariant] = useState("{}")
    const [promptState, setPromptState] = useState(null)
    //const [adjDistPrompts, setAdjDistPrompts] = useState(null)

    //Not sure now why in the else part that
    //I have to build the object from the object
    //and then stringfy it, but it seems to be working?  There
    //are some oddities still where the string from stringified 
    //object is different after it is stored and retrieved to use
    //as a key  (i.e. there are extra escape characters for "")
    const getVariantString = () => {
        if (Object.keys(distPromptState).length === 0){
            setStringVariant("{}")
        }
        else {
            let key = Object.keys(distPromptState)[0]
            let obj = {}
            obj[key] = distPromptState[key]               
            setStringVariant(JSON.stringify(obj) )
        }
    }

    //using this way of creating a new id string from the 
    //original key and val for some added bookkeeping because
    //the JSON stringify was causing oddball behavior.  I.e. 
    //adds extra escape characters when retrieve a stored key - PWJ 2/4/23
    const createVariantString = (key, val) => {
        let variant = key + ":" + val
        return variant
    }

    const submitDistPrompts = () => {
        setIntvVariant(intvVariant2JSON(distPromptState))
        getVariantString()}

    const submitPrompts = (event) => {
        setFormMode(FORM_MODES.DISP_NONE)
        let correctness = determineInterventionCorrectness()
        logIntv({
            interventionID: intvID,
            label: form.abbrLabel,
            patientStatus: determineInterventionStatus(correctness),
            type: "intervention",
            intvVariant: intvVariant,
            timestamp: getTimestamp(),
            answers: promptState,
            performedCorrectly: correctness,
            system: form.system || null,
            phase: currPhase,
            subPhase: currSubPhase
        })
        setCurrIntv(null)
       // setCurrIntvCat("")
        setShowIntvSelection(true)
    }

    const determineInterventionStatus = (correctness) => {
        let results = intvResults[intvID]
        let status = ""
        if (results){
            let type = results.type
            let statusType = results[scenario.name]
            let typeEntry = interventionStates[type]
            status = typeEntry[statusType]  
            if (!correctness && intvPromptResponsesWhereCorrectnessMatters.includes(intvID)){
                //could alternatively, just give the bad status value
                if (statusType === "good"){
                    status = "after adjustments, " + status[0].toLowerCase() + status.slice(1)
                }
                if (statusType === "neutral" && typeEntry["neutral"] === typeEntry["good"]){
                    status = "after adjustments, " + status[0].toLowerCase() + status.slice(1)
            }}
            
        }
        return status
    }

    const determinePromptCorrectness = (prompt, intvVariantAnswers) => {
        const selectionType = prompt.selectionType
        const allPromptAnswers = new Set(prompt.answers.map((ans) => ans.id));
        const correctAnswers = new Set(intvVariantAnswers[prompt.id]);
        const incorrectAnswers = difference(allPromptAnswers, correctAnswers)
        const selectedAnswers = new Set(promptState[prompt.id])
        console.log("selectionType", selectionType)
        //console.log("all answers", allPromptAnswers)
        console.log("correct answers", correctAnswers)
        //console.log("wrong answers", incorrectAnswers)
        console.log("selected answers", selectedAnswers)
        let retVal = false
        switch (selectionType) {
            case SELECTION_TYPES.ONE:
                retVal = radioCorrectness(correctAnswers, incorrectAnswers, selectedAnswers)
                break
            case SELECTION_TYPES.OOM_AND:
                retVal = logicalAndCorrectness(correctAnswers, incorrectAnswers, selectedAnswers)
                break
            case SELECTION_TYPES.OOM_OR:
                retVal = logicalOrCorrectness(correctAnswers, incorrectAnswers, selectedAnswers)
                break
            default:
                console.log("unsupported prompt semantics", selectionType)
                retVal = false
        }
        console.log(`${prompt.id} correctness: ${retVal}`)
        return retVal
    }

    const determineInterventionCorrectness = () => {
        // if there are no correct answers specified for this intervention, return false
        // else ALL prompts must be correct, each of whom's correctness is based off the semantics defined by
        // prompt.selectionType 
        if (! scenario.interventionVariantAnswers[intvID]) {
            // not a single intervention variant associated with answers, 
            // if no answers sought then can assume it is peformed correctly.
            // Otherwise it wasn't an intended intervention and so no correct
            // answers were recorded for it so still return true
            if (Object.keys(promptState).length === 0){
                return true}  //no answers were requested
            else {
                console.log(`${intvID} doesn't have any correct answers associated with it`)
                return true}
        }
         
        const intvVariantAnswers = getPrescribedInvAnswers(intvID, stringVariant, scenario)
        // default to true and if ANY prompt is answered incorrectly, set to false
        let performedCorrectly = true
        Object.keys(promptState).forEach(promptID => {
            const prompt = form.prompts.find(pr => pr.id === promptID)
            if (!determinePromptCorrectness(prompt, intvVariantAnswers)) {
                performedCorrectly = false
            }            
        })
        console.log(intvID, performedCorrectly)
        return performedCorrectly
    }


    const getSelected = (id, stateVar) => stateVar[id] || []
    
    const isSelected = (id, value, stateVar) => getSelected(id, stateVar).includes(value);

    const setSelected = (id, value, stateSetter) => {
        stateSetter((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    }

    const getDistPromptSelections = (id) => getSelected(id, distPromptState)
    const getPromptSelections = (id) => getSelected(id, promptState)


    const distPromptOptionIsSelected = (id, value) => isSelected(id, value, distPromptState)
    const promptOptionIsSelected = (id, value) => isSelected(id, value, promptState)

    const setDistPrompt = (id, value) => setSelected(id, value, setDistPromptState)
    const setPrompt = (id, value) => setSelected(id, value, setPromptState)

    // const setDistPromptOptionSelected = (id, value, checked) => setSelected(id, value, checked, distPromptState, setDistPromptState)

    // const setPromptOptionSelected = (id, value, checked) => setSelected(id, value, checked, promptState, setPromptState)

    const notDefaultValue = (val) => {
        let retVal = false
        if (typeof val === "string" && "" !== val) {
            retVal = true
        } else if (typeof val !== "string" && val.length > 0) {
            retVal = true
        }
        return retVal
    }

    function getIntvVariantLabels (interventionID) {
        let keys = []
        let intvEntry = scenario.interventionVariantAnswers[interventionID]
        if (intvEntry){
          for (const [key,] of Object.entries(intvEntry)) {
            let obj = JSON.parse(key)
            let vkey = Object.keys(obj)[0]
            let vval = Object.values(obj)[0]
            let result = createVariantString(vkey,vval)
            keys.push(result)
            }
        }
        return keys
    }
    
    
    
    const formComplete = (formState) => Object.values(formState).every(notDefaultValue)

    const distPromptFormComplete = () => formComplete(distPromptState)
    const promptFormComplete = () => formComplete(promptState)

    // returns mapping of keys to empty array
    const initializeState = (prompts) => {
        const tmp = {}
        prompts.forEach(p => tmp[p.id] = [])
        return tmp
    }

    //only display distinguishing prompts when there is more than
    //one instance of an intervention in the solution to a scenario
    function getAdjustedDistPrompts(distPromptsIn) {
        let labels = getIntvVariantLabels(intvID)
        let distPromptsOut = []
        let newPrompt
        distPromptsIn.forEach(prompt => {
            newPrompt = {...prompt}
            let adjustedAnswers = []
            prompt.answers.forEach(answer => {
                let label = createVariantString(answer.promptID, answer.id)
                if (labels.includes(label)){
                    adjustedAnswers.push(answer)
                    }
                })    
            newPrompt.answers = adjustedAnswers
            if(adjustedAnswers.length > 1){
                distPromptsOut.push(newPrompt)}})
        return distPromptsOut
    } 

    useEffect(
        
        // should only run on initial display of form
        () => {
            if (!form) {
                const frm = scenario.getInterventionForm(intvID)
                // initialize the dist prompts form
                const adjDistPrompts = getAdjustedDistPrompts(frm.distPrompts)
                frm.distPrompts = adjDistPrompts
                setForm(frm)
                console.log(frm)
                setDistPromptState(initializeState(adjDistPrompts))
                if (adjDistPrompts.length > 0) {
                    setFormMode(FORM_MODES.DISP_DIST_PROMPTS)
                } else {
                    setIntvVariant(JSON.stringify({}))
                    setFormMode(FORM_MODES.DISP_PROMPTS);
                }
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [intvID, form, scenario]
    )

    useEffect(
        () => {
            if (intvVariant && !promptState) {
                // once the intvVariant has been determined
                //   (whether by the user or automatic - when no alternates to choose from)
                // search the history for the most recent form submision for this intervention & variant,
                //    if found, init the form to those saved prompt answers
                //    else simply initialize empty form
                const hist = getIntvVariantHistory(intvID, intvVariant)
                if (hist.length > 0) {
                    console.log("intvVariant History", hist)
                    const lastVariantLogged = hist.slice(-1)[0]
                    console.log("most recent", lastVariantLogged)
                    setPromptState(lastVariantLogged.answers)
                } else {
                    setPromptState(initializeState(form.prompts))
                }
                setFormMode(FORM_MODES.DISP_PROMPTS)
            }
        }, [intvID, intvVariant, promptState, getIntvVariantHistory, form]
    )

    

    const displaySubForm = () => {
        switch (formMode) {
          case FORM_MODES.DISP_DIST_PROMPTS:
            return (
              <PromptsForm
                prompts={form.distPrompts}
                isSelected={distPromptOptionIsSelected}
                getSelected={getDistPromptSelections}
                setSelected={setDistPrompt}
                isDisabled={!distPromptFormComplete()}
                onSubmit={submitDistPrompts}
              />
            );
          case FORM_MODES.DISP_PROMPTS:
            if (!promptState) {
              // avoiding a race condition where we're waiting for state to be set which is async
              // and promptState still being undefined
              return <div>loading...</div>;
            }
            return (
              <PromptsForm
                prompts={form.prompts}
                isSelected={promptOptionIsSelected}
                getSelected={getPromptSelections}
                setSelected={setPrompt}
                isDisabled={!promptFormComplete()}
                onSubmit={submitPrompts}
              />
            );
          // some other case
          // reverse prompts stuff - unimplemented
          // {
          //     displaySubmit &&
          //         <
          //         ConfirmInterventionButton
          //     clickHandler = {
          //         confirmIntvHandler
          //     }
          //     enabled = {
          //         form.prompts.length === 0
          //     }
          //     />
          // }
          default:
            return (
              <div>
                Neither distPrompts nor prompts. Not sure what to display
                currently
              </div>
            );
        }
    }


    if (!form) {
        return (<div>processing....</div>)
    } 
    return (
      <Panel
        title={form.abbrLabel}
        centerTitle={true}
        collapsable={false}
        scrollBody={true}
      >
        {displaySubForm()}
      </Panel>
    )
}